import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import TopBar from "./TopBar/top-bar";
import { HomeBottom, HomeTop } from "./Pages/Home/home";
import UnderInfo from "./UnderInfo/under-info";
import { useEffect, useState } from "react";
import Photo_1 from "./svg/top_background_1.jpg"
import Photo_2 from "./svg/top_background_2.jpg"
import Photo_3 from "./svg/top_background_3.jpg"
import Services, { ServicesTop } from "./Pages/Services/services";
import PersonalInfo from "./Pages/Documents/PersonalInfoAgreementTrans/personal-info-agree-trans";
import PersonalInfoTrans from "./Pages/Documents/PersonalInfoAgreement/personal-info-agreement";

const App = () => {

  return (
    <BrowserRouter>
      {/* <div className="main_background"> */}

      <div className="main_scroll" id="main_scroll">
        <div className="main">
          <Routes>
            <Route exact path="/" element={<TopHeader />}></Route>
            <Route exact path="/services" element={<TopHeader />}></Route>
            <Route path="/documents/personal_info_agreement_trans" element={<></>}></Route>
            <Route path="/documents/personal_info_agreement" element={<></>}></Route>
          </Routes>

          <div className="main_top">
            <TopBar />
          </div>

          <div className="main_bottom">
            <div className="content">
              <Routes>
                <Route path="/" element={<HomeTop />}></Route>
                <Route path="/services" element={<ServicesTop />}></Route>
                <Route path="/documents/personal_info_agreement_trans" element={<></>}></Route>
                <Route path="/documents/personal_info_agreement" element={<></>}></Route>
              </Routes>


              <div className="content_content">
                <Routes>
                  <Route path="/documents/personal_info_agreement_trans" element={<PersonalInfo />}></Route>
                  <Route path="/documents/personal_info_agreement" element={<PersonalInfoTrans />}></Route>
                  <Route path="/" element={<HomeBottom />}></Route>
                  <Route path="/services" element={<Services />}></Route>
                </Routes>
              </div>

              <UnderInfo />
            </div>
          </div>

        </div>
        <div className="main_background"></div>
      </div>
      {/* </div> */}
    </BrowserRouter>
  );
};

export default App;

const TopHeader = () => {
  const [changeTopPhoto, setChangeTopPhoto] = useState(Photo_1);
  const [time, setTime] = useState(0);
  useEffect(() => {
    document.getElementById("main_backgound_top_photo").classList.toggle("visible");
    setTimeout(() => document.getElementById("main_backgound_top_photo") ? document.getElementById("main_backgound_top_photo").classList.toggle("visible") : null, 6300)
    setTimeout(() => setTime((prev) => prev == 2 ? prev = 0 : prev + 1), 7000);
    if (time == 0) {
      setChangeTopPhoto(Photo_1);
    }
    else if (time == 1)
      setChangeTopPhoto(Photo_2);
    else if (time == 2) {
      setChangeTopPhoto(Photo_3);
    }

  }, [time])

  return <div className="main_backgound_top">
    <div className="main_backgound_top_photo" id="main_backgound_top_photo" style={{ backgroundImage: `url(${changeTopPhoto})` }}></div>
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
      <path
        d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
        opacity=".25"
        className="shape-fill"
      ></path>
      <path
        d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
        opacity=".5"
        className="shape-fill"
      ></path>
      <path
        d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
        className="shape-fill"
      ></path>
    </svg>
  </div>
}